import { type AppEvent, type CheckoutSession } from "@/types";

const newEvent = (name: string): AppEvent => ({
  name,
});

export const SELECTED_PAYMENT_OPTION = newEvent("SELECTED_PAYMENT_OPTION");
export const ADD_NEW_CARD_CLICKED = newEvent("ADD_NEW_CARD_CLICKED");
export const ADD_NEW_CARD_SUBMITTED = newEvent("ADD_NEW_CARD_SUBMITTED");
export const VIEW_FINANCE_DOCUMENTS_CLICKED = newEvent(
  "VIEW_FINANCE_DOCUMENTS_CLICKED",
);
export const FINANCE_DOCUMENT_CLICKED = newEvent("FINANCE_DOCUMENT_CLICKED");
export const AGREE_TO_FINANCE_TERMS_CLICKED = newEvent(
  "AGREE_TO_FINANCE_TERMS_CLICKED",
);
export const HEADER_CART_CLICKED = newEvent("HEADER_CART_CLICKED");
export const HEADER_GO_BACK_CLICKED = newEvent("HEADER_GO_BACK_CLICKED");
export const BROWSER_BACK_CLICKED = newEvent("BROWSER_BACK_CLICKED");
export const SEE_PAYMENT_PLAN_DETAILS_CLICKED = newEvent(
  "SEE_PAYMENT_PLAN_DETAILS_CLICKED",
);
export const SWITCH_LANGUAGE_CLICKED = newEvent("SWITCH_LANGUAGE_CLICKED");
export const CONTINUE_CLICKED = newEvent("CONTINUE_CLICKED");
export const SELECTED_CARD = newEvent("SELECTED_CARD");
export const CASHBACK_TAG_CLICKED = newEvent("CASHBACK_TAG_CLICKED");
export const CLOSE_MODAL_CLICKED = newEvent("CLOSE_MODAL_CLICKED");
export const SCHEDULE_LIST_EXPAND_CLICKED = newEvent(
  "SCHEDULE_LIST_EXPAND_CLICKED",
);
export const SCHEDULE_LIST_COLLAPSE_CLICKED = newEvent(
  "SCHEDULE_LIST_COLLAPSE_CLICKED",
);
export const BUYER_PROTECTION_LABEL_CLICKED = newEvent(
  "BUYER_PROTECTION_LABEL_CLICKED",
);
export const TOTAL_BREAKDOWN_BUTTON_CLICKED = newEvent(
  "TOTAL_BREAKDOWN_BUTTON_CLICKED",
);
export const APR_DE_EMPHASIS_TOOLTIP_CLICKED = newEvent(
  "APR_DE_EMPHASIS_TOOLTIP_CLICKED",
);
export const WALLET_SELECTED = newEvent("WALLET_SELECTED");
export const WALLET_DESELECTED = newEvent("WALLET_DESELECTED");
export const CVV_MODAL_SHOWN = newEvent("CVV_MODAL_SHOWN");
export const ERROR_SCREEN_SHOWN = newEvent("ERROR_SCREEN_SHOWN");
export const DECLINE_UI_PAGE_SHOWN = newEvent("decline_ui_page_shown");
export const DECLINE_UI_BACK_TO_MERCHANT_CLICKED = newEvent(
  "decline_ui_back_to_merchant_clicked",
);
export const DECLINE_UI_ACTION_CLICKED = newEvent("decline_ui_action_clicked");
export const SINGLE_PAGE_CHECKOUT_SHOWN = newEvent("SINGLE_PAGE_CHECKOUT_SHOWN");
export const CHECKOUT_HANDSHAKE_COMPLETED = newEvent(
  "CHECKOUT_HANDSHAKE_COMPLETED",
);

// Screen lifecycle events for drop-off tracking
export const PAYMENT_PLAN_SELECTION_SCREEN_VIEWED = newEvent(
  "PAYMENT_PLAN_SELECTION_SCREEN_VIEWED",
);
export const PAYMENT_PLAN_SELECTION_SCREEN_EXITED = newEvent(
  "PAYMENT_PLAN_SELECTION_SCREEN_EXITED",
);
export const PAYMENT_CONFIRMATION_SCREEN_VIEWED = newEvent(
  "PAYMENT_CONFIRMATION_SCREEN_VIEWED",
);
export const PAYMENT_CONFIRMATION_SCREEN_EXITED = newEvent(
  "PAYMENT_CONFIRMATION_SCREEN_EXITED",
);
export const IVR_SCREEN_VIEWED = newEvent("IVR_SCREEN_VIEWED");
export const IVR_SCREEN_EXITED = newEvent("IVR_SCREEN_EXITED");

export const ALL_EVENTS = [
  SELECTED_PAYMENT_OPTION,
  ADD_NEW_CARD_CLICKED,
  ADD_NEW_CARD_SUBMITTED,
  AGREE_TO_FINANCE_TERMS_CLICKED,
  HEADER_CART_CLICKED,
  HEADER_GO_BACK_CLICKED,
  BROWSER_BACK_CLICKED,
  SEE_PAYMENT_PLAN_DETAILS_CLICKED,
  SWITCH_LANGUAGE_CLICKED,
  CONTINUE_CLICKED,
  SELECTED_CARD,
  CASHBACK_TAG_CLICKED,
  CLOSE_MODAL_CLICKED,
  SCHEDULE_LIST_EXPAND_CLICKED,
  SCHEDULE_LIST_COLLAPSE_CLICKED,
  BUYER_PROTECTION_LABEL_CLICKED,
  WALLET_DESELECTED,
  WALLET_DESELECTED,
  VIEW_FINANCE_DOCUMENTS_CLICKED,
  FINANCE_DOCUMENT_CLICKED,
  CVV_MODAL_SHOWN,
  TOTAL_BREAKDOWN_BUTTON_CLICKED,
  APR_DE_EMPHASIS_TOOLTIP_CLICKED,
  ERROR_SCREEN_SHOWN,
  DECLINE_UI_PAGE_SHOWN,
  DECLINE_UI_BACK_TO_MERCHANT_CLICKED,
  DECLINE_UI_ACTION_CLICKED,
  SINGLE_PAGE_CHECKOUT_SHOWN,
  CHECKOUT_HANDSHAKE_COMPLETED,
  PAYMENT_PLAN_SELECTION_SCREEN_VIEWED,
  PAYMENT_PLAN_SELECTION_SCREEN_EXITED,
  PAYMENT_CONFIRMATION_SCREEN_VIEWED,
  PAYMENT_CONFIRMATION_SCREEN_EXITED,
  IVR_SCREEN_VIEWED,
  IVR_SCREEN_EXITED,
];

export const defaultEventAttributes = (session: CheckoutSession) => ({
  order_id: session.orderId,
  checkout_id: session.id,
  checkout_status: session.status,
  merchant_id: session.merchant.id,
  customer_id: session.customerId,
  country: session.country.isoCode2,
});
